import { ErrorBase } from "@util/errors";
import { DateString } from "@util/types";

export class DivisionNotFoundError extends ErrorBase {
	static errorId = "division-not-found";
	constructor() {
		super("Der Standort wurde nicht gefunden.");
	}
}

export class DeleteDivisionWithVoucherError extends Error {
	constructor() {
		super("Cannot delete division, vouchers uploaded by users");
	}
}

export class DivisionCreationCustomerStatusError extends ErrorBase {
	static errorId = "division-creation-status-error";
	constructor() {
		super(
			`Der Standort kann nicht erstellen werden, da der Kunde entweder deaktiviert oder archiviert ist`
		);
	}
}

type CategoryDisabledDetails = {
	categoryNames: string[];
	userName: string;
	userEmail: string;
};

export class CategoryDisabledError extends ErrorBase {
	static fromErrorResponse(payload: {
		currentOpenAccountingPeriodStart: DateString;
		categories: {
			categories: {
				id: string;
				name: string;
				longName: string;
			}[];
			user: {
				customerId: string;
				divisionId: string;
				userId: string;
				email: string;
				name: string;
			};
		}[];
	}): CategoryDisabledError {
		return new CategoryDisabledError(
			payload.categories.map((group) => ({
				categoryNames: group.categories.map((category) => category.name),
				userName: group.user.name,
				userEmail: group.user.email,
			})),
			payload.currentOpenAccountingPeriodStart
		);
	}

	static errorId = "category-disabled" as const;
	constructor(
		categories: CategoryDisabledDetails[],
		accountingPeriodStart: string
	) {
		const rows = categories
			.map(
				({ categoryNames, userName, userEmail }) =>
					`  • ${userName} (${userEmail}): \n \u2003 Kategorien: ${categoryNames.join(
						", "
					)}`
			)
			.join("\n");
		super(
			`Folgende Budget-Kategorien sind für den Standort nicht freigeschaltet, werden im aktuellen Abrechnungsmonat (ab ${accountingPeriodStart}) aber noch aktiv genutzt:\n\n${rows}\n\nBitte zunächst die Moduleinstellungen anpassen.`
		);
	}
}

export class ExcessBudgetConfigurationInvalidError extends ErrorBase {
	static fromErrorResponse(payload: {
		user: {
			customerId: string;
			divisionId: string;
			userId: string;
			email: string;
			name: string;
		};
	}): ExcessBudgetConfigurationInvalidError {
		return new ExcessBudgetConfigurationInvalidError(
			payload.user.name,
			payload.user.email
		);
	}

	static errorId = "excess-budget-configuration-invalid" as const;
	constructor(userName: string, userEmail: string) {
		super(
			`Überschussbudget muss an den Standorteinstellungen aktiviert sein, um es verwenden zu können. Betroffen ist der Benutzer ${userName} (${userEmail}).`
		);
	}
}
